<form [formGroup]="createInstanceForm" class="create-instance-form">
  <div class="flex flex-col">
    <div class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12 instance-label-align">{{'INSTANCE_SUMMARY.INSTANCE_NAME' | transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.INSTANCE_NAME' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <input formControlName="name" placeholder="{{'INSTANCE_SUMMARY.INSTANCE_NAME' | transloco}}" class="fw-400" (click)="onClick()"  required>
      <app-error [control]="createInstanceForm.get('name')"></app-error>
    <div *ngIf="envt!=='dev'&& envt!=='preprod'">
      <div *ngIf="instanceName else disablebutton">
      <button class="link-field mt-5 fw-400 pl-12">
        <div *ngIf="deployment?.dataZone !== DataZone.LIVE; else prodEnvironments" class="flex items-center">
          <span class="button-text">{{blueprint.name | trim | lowercase}}-{{createInstanceForm.get('name').value | trim | lowercase}}.{{tenantDetails.tenantId}}.{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.TEMENOSBANKINGDEV_CLOUD' | transloco}}</span>
        </div>
        <ng-template #prodEnvironments>
          <span class="button-text">{{blueprint.name | trim | lowercase}}.{{tenantDetails.tenantId}}.{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.TEMENOSBANKING_CLOUD'| transloco}}</span>
        </ng-template>
      </button>
      </div>
      <ng-template #disablebutton>
        <button class="link-field mt-5 fw-200 hide">
          <div *ngIf="deployment?.dataZone !== DataZone.LIVE; else prodEnvironments" class="flex items-center">
            <span class="button-text">{{blueprint.name | trim | lowercase}}-{{createInstanceForm.get('name').value | trim | lowercase}}.{{tenantDetails.tenantId}}.{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.TEMENOSBANKINGDEV_CLOUD' | transloco}}</span>
          </div>
          <ng-template #prodEnvironments>
            <span class="button-text">{{blueprint.name | trim | lowercase}}.{{tenantDetails.tenantId}}.{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.TEMENOSBANKING_CLOUD'| transloco}}</span>
          </ng-template>
        </button>
      </ng-template>
    </div>

      <div *ngIf="envt==='dev'">
      <div *ngIf="instanceName else disablebutton">
        <button class="link-field mt-5 fw-400">
            <span class="button-text">{{blueprint.name | trim | lowercase}}-{{createInstanceForm.get('name').value | trim | lowercase}}-{{tenantDetails.tenantId}}.{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.DEV_TEMENOS_CLOUD' | transloco}}</span>
        </button>
        </div>
        <ng-template #disablebutton>
          <button class="link-field mt-5 fw-200 hide">    
              <span class="button-text">{{blueprint.name | trim | lowercase}}-{{createInstanceForm.get('name').value | trim | lowercase}}-{{tenantDetails.tenantId}}.{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.DEV_TEMENOS_CLOUD' | transloco}}</span>
          </button>
        </ng-template>
      </div>

      <div *ngIf="envt==='preprod'">
        <div *ngIf="instanceName else disablebutton">
          <button class="link-field mt-5 fw-400">
              <span class="button-text">{{blueprint.name | trim | lowercase}}-{{createInstanceForm.get('name').value | trim | lowercase}}-{{tenantDetails.tenantId}}.{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.PREPROD_TEMENOS_CLOUD' | transloco}}</span>
          </button>
          </div>
          <ng-template #disablebutton>
            <button class="link-field mt-5 fw-200 hide">    
                <span class="button-text mat-body-1">{{blueprint.name | trim | lowercase}}-{{createInstanceForm.get('name').value | trim | lowercase}}-{{tenantDetails.tenantId}}.{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.PREPROD_TEMENOS_CLOUD' | transloco}}</span>
            </button>
          </ng-template>
        </div>

    </div>
    <div class="flex-col form-field mb-8">
      <div class="flex-row mb-4">
        <label class="fs-12 instance-label-align">{{'INSTANCE_SUMMARY.SERVICE_DEFINITION.SERVICE_DEFINITION' | transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.SERVICE_DEFINITION_VERSION' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <select (change)="getVersion($event.target.value)" [formControl]="createInstanceForm.get('blueprintVersionId')">
        <option *ngFor="let version of versions" [ngValue]="version.id">{{'INSTANCE_SUMMARY.SERVICE_DEFINITION.VERSION' | transloco}} {{ version.version }}</option>
      </select>
      <app-error [control]="createInstanceForm.get('blueprintVersionId')"></app-error>
    </div>
    <div class="flex-col form-field mb-8">
      <div class="flex-row mb-4">
        <label class="fs-12 instance-label-align">{{'BLUEPRINT_SUMMARY.DEPLOYMENT_CLASS'| transloco | uppercase}}</label> 
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'BLUEPRINT_SUMMARY.DEPLOYMENT_CLASS' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <select [formControl]="createInstanceForm.get('deploymentClass')" [attr.disabled]="true" class="disabled">
        <option *ngFor="let class of classDropdown" [ngValue]="class">{{class}}</option>
      </select>
      <app-error [control]="createInstanceForm.get('deploymentClass')"></app-error>
    </div>
    <div class="flex-col form-field mb-8">
      <div class="flex-row mb-4">
        <label class="fs-12 instance-label-align">{{'BLUEPRINT_SUMMARY.RELEASE'| transloco | uppercase}}</label> 
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.SOLUTION_RELEASE' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <select [formControl]="createInstanceForm.get('buildNumber')" (change)="getBuildVersion($event.target.value)" [attr.disabled]="true">
        <option *ngFor="let buildNumber of finalBuild" [value]="buildNumber?.version">{{buildNumber?.releaseVersion}}</option>
      </select>
      <app-error [control]="createInstanceForm.get('buildNumber')"></app-error>
    </div>
    <div class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12 instance-label-align">{{'INSTANCE_SUMMARY.ENVIRONMENT' | transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.ENVIRONMENT' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <input placeholder="{{'INSTANCE_SUMMARY.ENVIRONMENT' | transloco}}" class="fw-400" value="{{(deployment | resolveDeploymentSubscription) === 'TEST'? (devInstanceEnvironment): deployment?.dataZone === DataZone.DEVELOPMENT? (devInstanceEnvironment | titlecase): (devInstanceEnvironment)}}" readonly>
      <input hidden formControlName="targetEnvironment" placeholder="{{'INSTANCE_SUMMARY.ENVIRONMENT' | transloco}}" class="fw-400" readonly>
    </div>

    <div class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12 instance-label-align">{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.DATA_ZONE' | transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.DATA_ZONE' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <input value="{{deployment | resolveDeploymentSubscription | titlecase}}" placeholder="{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.DATA_ZONE' | transloco}}" class="fw-400" readonly>
    </div>

    <!-- <div *ngIf="deployment?.dataZone === DataZone.LIVE" class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12">{{ 'SERVICE.PREFERED_MAINTENANCE_DAY' | transloco | uppercase }}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltip=""
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <select [formControl]="createInstanceForm.get('dayOfTheWeek')">
        <option [ngValue]="null" [disabled]="true" hidden>{{'SERVICE.PREFERED_MAINTENANCE_DAY' | transloco}}</option>
        <option *ngFor="let day of weekDays; let i = index" [ngValue]="i">{{ day }}</option>
      </select>
      <app-error [control]="createInstanceForm.get('dayOfTheWeek')"></app-error>
    </div>

    <div *ngIf="deployment?.dataZone === DataZone.LIVE" class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12">{{ 'SERVICE.PREFERED_MAINTENANCE_TIME' | transloco | uppercase }}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltip=""
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <div class="flex flex-row">
        <div>
          <div class="maintenance-time">
            <div class="justify-items-center timepicker">
              <input [placeholder]="'SERVICE.FROM' | transloco" aria-label="12hr format" class="field-enabled"
                [formControl]="createInstanceForm.get('startingHour')" [matTimepicker]="startingHour" [format]="12" readonly>
              <mat-icon svgIcon="schedule" class="items-center mt-10 timepicker-icon" (click)="startingHour.open()"></mat-icon>
              <mat-timepicker #startingHour></mat-timepicker>
            </div>
          </div>
          <app-error [control]="createInstanceForm.get('startingHour')"></app-error>
        </div>
        <div>
          <div class="maintenance-time">
            <div class="justify-items-center timepicker">
              <input [placeholder]="'SERVICE.TO' | transloco" aria-label="12hr format" class="field-enabled"
                [formControl]="createInstanceForm.get('endingHour')" [ngxMatTimepicker]="endingHour" [format]="12" readonly>
              <mat-icon svgIcon="schedule" class="items-center mt-10 timepicker-icon" (click)="endingHour.open()"></mat-icon>
              <ngx-mat-timepicker #endingHour></ngx-mat-timepicker>
            </div>
          </div>
          <app-error [control]="createInstanceForm.get('endingHour')"></app-error>
        </div>
      </div>
    </div> -->

    <div class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12 instance-label-align">{{'INSTANCE_SUMMARY.SERVICE' | transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.SOLUTION_NAME' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <input placeholder="{{'INSTANCE_SUMMARY.SERVICE' | transloco}}" class="fw-400" value="{{service.name}}" readonly>
    </div>

    <div class="flex-col form-field">
      <div class="flex-row mb-4">
        <label class="fs-12 instance-label-align">{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.REGION' | transloco | uppercase}}</label>
        <mat-icon svgIcon="info" class="info-icon ml-10" matTooltipClass="right" [matTooltip]="'INSTANCE_SUMMARY.TOOLTIP.REGION' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <input formControlName="region" placeholder="{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.REGION' | transloco}}" class="fw-400" readonly>
    </div>    
  </div>
</form>
